import { apiFetch } from "../client"

export async function listUsers(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/users${query}`)
}

export async function getUser(userId: string) {
  return apiFetch<any>(`/users/${userId}`)
}

export async function createUser(payload: object) {
  return apiFetch<any>("/users", {
    method: "POST",
    rawBody: payload,
  })
}

export async function updateUser(userId: string, payload: object) {
  return apiFetch<any>(`/users/${userId}`, {
    method: "PATCH",
    rawBody: payload,
  })
}

export async function unlockUser(userId: string, note: string) {
  return apiFetch<any>(`/users/${userId}/unlock`, {
    method: "POST",
    rawBody: { note },
  })
}

export async function resetUserOtp(userId: string, note: string) {
  return apiFetch<any>(`/users/${userId}/reset-otp`, {
    method: "POST",
    rawBody: { note },
  })
}

export async function deactivateUser(userId: string, note: string) {
  return apiFetch<any>(`/users/${userId}/deactivate`, {
    method: "POST",
    rawBody: { note },
  })
}

export async function reactivateUser(userId: string, note: string) {
  return apiFetch<any>(`/users/${userId}/reactivate`, {
    method: "POST",
    rawBody: { note },
  })
}

export function getUsersExportUrl(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return `/api/v1/users/export${query}`
}
